import { useCallback } from 'react'

import { getPickupAddressPointDetails } from '@/services/pickup-address-point/get-details'
import { PickupAddressPointDetailsResponse } from '@/services/pickup-address-point/interface'

export const usePickupAddressPointGetDetails = () => {
  const fetchDetails = useCallback(
    async (idPostoDeColeta: string): Promise<PickupAddressPointDetailsResponse | null> => {
      try {
        const response = await getPickupAddressPointDetails(idPostoDeColeta)
        return response
      } catch (error) {
        console.error('Error fetching pickup address point details:', error)
        return null
      }
    },
    []
  )

  return { fetchDetails }
}
